import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue'
import Modal from '@/util/Modal.vue'
import ContactInfo from './ContactInfo.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ContactInfoModal',
  setup(__props, { expose: __expose }) {

__expose({
  open,
})

const userIdRef = ref<string>()
const busyRef = ref(false)

const modalRef = ref<InstanceType<typeof Modal>>()
const contactInfoRef = ref<InstanceType<typeof ContactInfo>>()


function open(userId: string) {
  userIdRef.value = userId
  modalRef.value?.open()
}

function canSaveChanges() {
  return contactInfoRef.value?.canSave()
}

async function saveChanges() {
  try {
    busyRef.value = true
    await contactInfoRef.value?.saveAsync()
    await modalRef.value?.close()
  }
  finally {
    busyRef.value = false
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    ref_key: "modalRef",
    ref: modalRef,
    class: "",
    "ok-disabled": !canSaveChanges(),
    onOk: saveChanges
  }, {
    title: _withCtx(() => [
      _createTextVNode("Contact info")
    ]),
    default: _withCtx(() => [
      _createVNode(ContactInfo, {
        ref_key: "contactInfoRef",
        ref: contactInfoRef,
        "user-id": userIdRef.value,
        disabled: busyRef.value
      }, null, 8, ["user-id", "disabled"])
    ]),
    _: 1
  }, 8, ["ok-disabled"]))
}
}

})